export const actions = {
    LOADING: 'LOADING',
    LOG_IN: 'LOG_IN',
    LOG_OUT: 'LOG_OUT',
    IMPERSONATE: 'IMPERSONATE',
    LOAD_INITIAL_DATA: 'LOAD_INITIAL_DATA',
    LOG_OUT_IMPERSONATE: 'LOG_OUT_IMPERSONATE',
    PK_OPERADOR: 'PK_OPERADOR',
    BUSINESS_AND_DATA: 'BUSINESS_AND_DATA',
    UPDATED_AT: 'UPDATED_AT'
}